<template>
  <section>
    <div class="py-5 dark-section">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-6 mb-4 mb-md-0 text-slide-in" :class="{ 'text-slide-in-active': textVisible }">
            <h2 class="highlight-text highlight-text-margin">LLM-basiertes Wissensmanagement</h2>
            <p class=" mb-4">
              Steigern Sie die Effizienz Ihres Wissensmanagements durch den Einsatz von LLMs wie ChatGPT, um Unternehmenswissen intelligent zu organisieren, zugänglich zu machen und nutzbar zu gestalten. Nutzen Sie KI, um Ihr Wissen optimal zu verwalten und eine effektive Entscheidungsfindung zu fördern.
            </p>
<!--            <router-link :to="{ name: 'LLM' }" class="btn btn-primary btn-lg mt-2">-->
<!--              Kontaktieren Sie uns-->
<!--              <i class="fas fa-envelope"></i>-->
<!--            </router-link>-->
          </div>
          <div class="col-md-6 text-center">
            <img
                src="@/assets/llm/llm.jpg"
                alt="Motivation für LLM-basiertes Wissensmanagement"
                class="img-fluid rounded-img shadow-sm top-image"
                :class="{ 'slide-in-active': imageVisible }"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="py-5 light-section">
      <div class="container">
        <div class="row text-center mb-5">
          <div class="col-md-4">
            <i class="fas fa-book fa-3x mb-3" style="color: #e2a84b;"></i>
            <h4 >KI-gestütztes Wissen organisieren</h4>
            <p >
              Organisieren Sie Ihr Wissen intelligent mit KI-Unterstützung und machen Sie es leicht zugänglich für alle Mitarbeiter.
            </p>
          </div>
          <div class="col-md-4">
            <i class="fas fa-file-alt fa-3x mb-3" style="color: #e2a84b;"></i>
            <h4 >Automatisierte Berichterstellung</h4>
            <p >
              Erstellen Sie Berichte automatisiert und umfassend, um die Effizienz Ihrer internen Kommunikation zu steigern.
            </p>
          </div>
          <div class="col-md-4">
            <i class="fas fa-headset fa-3x mb-3" style="color: #e2a84b;"></i>
            <h4 >Optimierte Kundenkommunikation</h4>
            <p >
              Verbessern Sie Ihre Kundenkommunikation proaktiv durch maßgeschneiderte Antworten und erhöhte Effizienz.
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="py-5 dark-section">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-6 text-center">
            <img
                src="@/assets/llm/llm2.jpg"
                alt="Unsere LLM-basierte Wissensmanagement-Lösung"
                class="img-fluid rounded-img shadow-sm solution-image"
                :class="{ 'slide-in-active': solutionImageVisible }"
            />
          </div>
          <div class="col-md-6 mb-4 mb-md-0 text-slide-up" :class="{ 'text-slide-up-active': solutionTextVisible }">
            <h2 >Unsere Lösung</h2>
            <p class=" mb-4">
              Mit unseren maßgeschneiderten LLM-basierten Wissensmanagement-Lösungen können Sie Wissen effizient verwalten, komplexe Berichte erstellen und eine optimierte Kommunikation aufbauen – für ein dynamisches, zukunftsorientiertes Unternehmen.
            </p>
            <router-link to="/contact" class="btn btn-primary btn-lg mt-2">
              Jetzt Kontakt aufnehmen
              <i class="fas fa-envelope"></i>
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <div class="py-5 light-section">
      <div class="container">
        <div class="row text-center">
          <div class="col-md-12">
            <h2 >Ihre Vorteile</h2>
            <p class=" mb-4">
              Profitieren Sie von intelligentem Wissensmanagement durch LLMs und heben Sie Ihre Entscheidungsfindung und Effizienz auf das nächste Level.
            </p>
          </div>
        </div>
        <div class="row text-center mt-4">
          <div class="col-md-4">
            <i class="fas fa-brain fa-3x mb-3" style="color: #e2a84b;"></i>
            <h4 >Intelligente Wissensorganisation</h4>
            <p >KI unterstützt die strukturierte Organisation Ihres Wissens, um eine fundierte Entscheidungsbasis zu schaffen.</p>
          </div>
          <div class="col-md-4">
            <i class="fas fa-file-alt fa-3x mb-3" style="color: #e2a84b;"></i>
            <h4 >Umfassende Berichte</h4>
            <p >Erstellen Sie detaillierte Berichte schnell und effizient mit KI-Unterstützung für maximale Transparenz.</p>
          </div>
          <div class="col-md-4">
            <i class="fas fa-headset fa-3x mb-3" style="color: #e2a84b;"></i>
            <h4 >Optimierte Kommunikation</h4>
            <p >Verbessern Sie die Kundenkommunikation und bieten Sie maßgeschneiderte, proaktive Antworten.</p>
          </div>
        </div>
      </div>
    </div>

  </section>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from 'vue';

export default defineComponent({
  name: 'LLMKnowledgeManagementPage',
  setup() {
    const textVisible = ref(false);
    const imageVisible = ref(false);
    const solutionTextVisible = ref(false);
    const solutionImageVisible = ref(false);

    onMounted(() => {
      const observerOptions = {
        root: null,
        threshold: 0.1,
      };

      const observerCallback = (entries: IntersectionObserverEntry[]) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            if (entry.target.classList.contains('top-image')) {
              imageVisible.value = true;
            } else if (entry.target.classList.contains('solution-image')) {
              solutionImageVisible.value = true;
            } else if (entry.target.classList.contains('text-slide-in')) {
              textVisible.value = true;
            } else if (entry.target.classList.contains('text-slide-up')) {
              solutionTextVisible.value = true;
            }
          }
        });
      };

      const observer = new IntersectionObserver(observerCallback, observerOptions);

      document.querySelectorAll('.text-slide-in, .top-image, .solution-image, .text-slide-up').forEach(element => {
        observer.observe(element);
      });
    });

    return { textVisible, imageVisible, solutionTextVisible, solutionImageVisible };
  },
});
</script>

<style scoped lang="less">
@import '@/assets/style.less';
@import "@/assets/animations.less";

.top-image {
  margin-top: 2rem;
}
</style>
